<template>
  <div v-if="editFastHouse" class="realative">
    <div class="text-white w-[420px] rounded-md">
      <h1 class="mt-2 text-2xl px-3 font-semibold">
        Редактировать быстрый адрес
      </h1>
      <div class="flex justify-between items-center my-4 px-3">
        <label class="text-sm">Название</label>
        <input
          placeholder="Название"
          v-model="editFastHouse.name"
          class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
          type="text"
        />
      </div>
      <div class="flex justify-between items-center my-4 px-3">
        <label class="text-sm">Почтовый индекс</label>
        <input
          placeholder="Почтовый индекс"
          class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
          type="text"
          v-model="editFastHouse.postCode"
        />
      </div>
      <div
        v-if="categories"
        class="flex justify-between items-center my-4 px-3"
      >
        <label class="text-sm">Категория</label>
        <div class="w-[270px]">
          <customSelect
            :options="categories"
            v-model="editFastHouse.category_id.id"
            placeholder="Категория"
            value-key="id"
            ref="villageSelect"
            label="name"
            @onSelect="getCategory"
            :search="true"
          ></customSelect>
        </div>
      </div>
      <!-- <div class="flex justify-between my-4 px-3">
                <input type="checkbox" class="mt-1.5 mr-2">
                <div>Показывать на карте вместо улицы и номера дома </div>
            </div>  -->
      <div v-if="streets" class="flex justify-between items-center my-4 px-3">
        <label class="text-sm">Улица</label>
        <div class="w-[270px]">
          <customSelect
            :options="streets"
            v-model="editFastHouse.street_id.streetCode"
            placeholder="Улица"
            label="displayName"
            value-key="streetCode"
            @onSelect="getSteets"
            :search="true"
          ></customSelect>
        </div>
      </div>
      <div
        v-if="home_numbers"
        class="flex justify-between items-center my-4 px-3"
      >
        <label class="text-sm">Номер дома</label>
        <div class="w-[270px]">
          <customSelect
            :options="home_numbers"
            placeholder="Номер дома"
            v-model="editFastHouse.number_id.addressCode"
            @onSelect="getNumHome"
            label="houseNum"
            value-key="addressCode"
            :search="true"
          ></customSelect>
        </div>
      </div>
      <div class="flex justify-between items-center my-4 px-3">
        <div class="text-sm">Координаты</div>
        <input
          disabled
          class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
          type="text"
          v-model="textCoordinates"
        />
      </div>
      <div class="my-1 px-3">
        <div class="text-sm">Описание</div>
        <textarea
          v-model="editFastHouse.description"
          placeholder="Описание"
          class="border rounded w-full text-sm text-black px-2 py-1 h-[60px]"
          type="text"
        ></textarea>
      </div>
      <!-- <div class="flex my-4 px-3">
        <div class="bg-white text-black rounded-sm mr-2 p-1 cursor-pointer">
          Места встреч (0)
        </div>
        <div
          class="bg-white text-black rounded-sm mr-2 p-1 cursor-pointer"
          @click="showSynonyms"
        >
          Синонимы ({{ lines.length }})
        </div>
      </div> -->
      <div v-if="synonymModal">
        <h1 class="text-2xl px-3 font-semibold">Синонимы</h1>
        <div
          class="flex justify-between my-4 px-3"
          v-for="(line, index) in lines"
          :key="index"
        >
          <input class="w-80 text-black" type="text" v-model="line.name" />
          <div class="bg-white text-black rounded-sm mr-1 px-2 cursor-pointer">
            <i class="ri-delete-bin-line" @click="removeLine(index)"></i>
          </div>
        </div>
        <div class="flex justify-end my-4 px-3">
          <div
            class="bg-white text-black rounded-sm mr-1 py-1 px-3 cursor-pointer"
            @click="addLine"
          >
            +
          </div>
        </div>
      </div>
      <div class="flex my-4 px-3">
        <div
          @click="$emit('close'), $emit('updateMarker')"
          class="bg-white text-black rounded-sm mr-2 p-1 cursor-pointer"
        >
          Отмена
        </div>
        <div
          class="bg-white text-black rounded-sm p-1 cursor-pointer ml-auto"
          @click="editAddress(1)"
        >
          Заблокировать
        </div>
        <button
          @click="editAddress(0)"
          :disabled="editRequestLoading"
          class="bg-black/40 text-white rounded mx-2 p-1 cursor-pointer"
        >
          Сохранить
        </button>
      </div>
    </div>
    <loader :open="loader" :local="true" />
  </div>
</template>

<script>
import customSelect from "@/components/custom/customSelect/index.vue";
import loader from "@/components/custom/customLoader/index.vue";
export default {
  props: ["village_id", "coordinateDragendMarkerFast", "categories"],
  components: {
    customSelect,
    loader,
  },
  data() {
    return {
      loader: false,
      editFastHouse: {
        name: "",
        category_id: {
          id: null,
          name: null,
        },
        street_id: {
          displayName: null,
          streetCode: null,
        },
        number_id: {
          addressCode: null,
          houseNum: null,
        },
        lat: null,
        lng: null,
        description: "",
        getDescription: "",
        postCode: "",
        id: "",
      },
      category_id: null,
      street_id: null,
      number_id: null,
      editRequestLoading: false,
      home_numbers: null,
      synonymModal: false,
      lines: [],
      name: "",
      lat: "",
      lng: "",
      textCoordinates: "",
      streets: [],
    };
  },
  methods: {
    getFastAddress(id) {
      this.loader = true;
      this.$http
        .get(`v1/poi/points/${id.id}`)
        .then((res) => {
          this.clearData();
          this.editFastHouse.description = res.data.description;
          this.editFastHouse.name = res.data.name;
          this.editFastHouse.lat = res.data.lat;
          this.editFastHouse.lng = res.data.lng;
          this.editFastHouse.id = res.data.id;
          this.getHomeNumbers();
          this.getStreets();
          if (res.data.category) {
            this.category_id = {
              id: res.data.category.id,
              name: res.data.category.name,
            };
          }
          if (this.category_id) {
            this.editFastHouse.category_id.id = this.category_id.id;
            this.editFastHouse.category_id.name = this.category_id.name;
          }
          this.editFastHouse.street_id = {
            streetCode: res.data.streetCode,
            displayName: res.data.streetName,
          };
          this.street_id = {
            streetCode: res.data.streetCode,
            displayName: res.data.streetName,
          };
          this.editFastHouse.number_id = {
            addressCode: res.data.addressCode,
            houseNum: res.data.addressName,
          };
          this.number_id = {
            addressCode: res.data.addressCode,
            houseNum: res.data.addressName,
          };
          this.textCoordinates = `${res.data.lat}, ${res.data.lng}`;
          this.$nextTick(() => {
            this.$refs.villageSelect.updateText();
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    getStreets() {
      this.$http
        .get(`v1/polygons/${this.village_id}/streets`, {
          params: { lng: this.editFastHouse.lng, lat: this.editFastHouse.lat },
        })
        .then((res) => {
          this.streets = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getHomeNumbers() {
      this.$http
        .get(
          `v1/poi/addresses?lng=${this.editFastHouse.lng}&lat=${this.editFastHouse.lat}`
        )
        .then((res) => {
          this.home_numbers = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCategory(event) {
      this.category_id = event;
    },
    getSteets(event) {
      this.street_id = event;
      this.getDescription();
    },
    getNumHome(event) {
      this.number_id = event;
      this.getDescription();
    },
    getDescription() {
      if (this.street_id && this.number_id) {
        this.editFastHouse.getDescription = `${this.street_id.displayName}, ${this.number_id.houseNum}`;
      }
    },
    showSynonyms() {
      this.synonymModal = !this.synonymModal;
    },
    addLine() {
      this.lines.push({ name: "" });
    },
    removeLine(index) {
      this.lines.splice(index, 1);
    },
    editAddress(blocked) {
      this.loader = true;
      this.editRequestLoading = true;
      let data = {
        addressCode: this.number_id
          ? this.number_id.addressCode
          : this.editFastHouse.number_id.addressCode,
        name: this.editFastHouse.name,
        postCode: this.editFastHouse.postCode,
        description: this.editFastHouse.description
          ? this.editFastHouse.description
          : this.editFastHouse.getDescription
          ? this.editFastHouse.getDescription
          : "",
        categoryId: this.category_id
          ? this.category_id.id
          : this.editFastHouse.category_id.id,
        streetCode: this.street_id
          ? this.street_id.streetCode
          : this.editFastHouse.street_id.streetCode,
        lat: this.editFastHouse.lat,
        lng: this.editFastHouse.lng,
        blocked: blocked,
        id: this.editFastHouse.id,
      };
      this.$http
        .patch(`v1/poi/points/${this.editFastHouse.id}`, data)
        .then((res) => {
          this.editRequestLoading = false;
          this.$toast.open({
            message: "Адрес успешно изменен",
            type: "success",
            position: "top",
          });
          this.$emit("close");
          this.$emit("updateMarker", blocked, res.data, this.editFastHouse.id);
        })
        .catch((err) => {
          this.editRequestLoading = false;
          this.$toast.open({
            message: err.response.data.errors,
            type: "error",
            position: "top",
          });
        })
        .finally(() => {
          this.editRequestLoading = false;
          this.loader = false;
        });
    },
    clearData() {
      (this.editFastHouse = null),
        (this.editFastHouse = {
          name: "",
          category_id: {
            id: null,
            name: null,
          },
          street_id: {
            displayName: null,
            streetCode: null,
          },
          number_id: {
            addressCode: null,
            houseNum: null,
          },
          lat: null,
          lng: null,
          description: "",
          getDescription: "",
          postCode: "",
          id: "",
        }),
        (this.editRequestLoading = false),
        (this.home_numbers = null),
        (this.synonymModal = false),
        (this.lines = []),
        (this.name = ""),
        (this.lat = ""),
        (this.lng = ""),
        (this.textCoordinates = "");
      (this.category_id = null),
        (this.street_id = null),
        (this.number_id = null);
    },
  },
  watch: {
    coordinateDragendMarkerFast(newValue) {
      this.editFastHouse.lat = newValue.lat;
      this.editFastHouse.lng = newValue.lng;
      this.textCoordinates = `${newValue.lat}, ${newValue.lng}`;
      this.getHomeNumbers();
    },
  },
  computed: {
    coordinates() {
      return JSON.stringify([this.editFastHouse.lat, this.editFastHouse.lng]);
    },
  },
};
</script>
